import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics 4 loader + SPA pageview tracker.
 *
 * Set REACT_APP_GA4_MEASUREMENT_ID in frontend/.env (e.g. G-XXXXXXX) and
 * mount <Analytics/> once in App.js. When the env var is missing the hook
 * does nothing, so the site continues to work in preview/local without
 * leaking any pageviews.
 */
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

function loadScript(id) {
  if (typeof window === 'undefined') return;
  if (window.__ga4_loaded) return;
  window.__ga4_loaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  // Manual send_page_view so we can fire on route change (SPA).
  gtag('config', id, { send_page_view: false });
}

const Analytics = () => {
  const location = useLocation();
  const initialised = useRef(false);

  useEffect(() => {
    if (!GA_ID) return;
    if (!initialised.current) {
      loadScript(GA_ID);
      initialised.current = true;
    }
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
